export default __webpack_public_path__ + "static/media/running_club.923aac4f.jpg";